export default __webpack_public_path__ + "static/home_bodegon_paraguay-a1b6ee9f28ea5f047e5170b5a4f70fcd.png";